import XLSX from "xlsx-js-style";
import {
  append_export_answer,
  append_export_answer_to_row,
  apply_export_links,
  build_export_headers,
  build_export_rows,
  create_respondent_export_row,
  format_export_value,
  get_export_column_widths,
  get_export_data_cell_style,
  get_export_header_style,
  get_export_link_cell_style,
  get_survey_result_export_value,
  get_survey_result_response_key,
  get_survey_result_row,
  prepare_worksheet,
  write_survey_results_export_file,
} from "./survey_export_utils";

export const survey_export_methods = {
  create_survey_results_export_respondent(user) {
    return create_respondent_export_row(user);
  },
  get_survey_results_export_response_key(user_id, survey_question, question_index, answer_index) {
    return get_survey_result_response_key(user_id, survey_question, question_index, answer_index);
  },
  get_or_create_survey_results_export_row(respondents, response_key, user) {
    return get_survey_result_row(respondents, response_key, user);
  },
  merge_survey_results_export_answer(row, question_text, next_answer) {
    append_export_answer(row, question_text, next_answer);
  },
  append_survey_results_export_answer(respondents, survey_question, question_text, question_index, answer, answer_index) {
    append_export_answer_to_row(this, respondents, survey_question, question_text, question_index, answer, answer_index);
  },
  get_survey_results_export_rows(survey) {
    const questions = Array.isArray(survey?.survey_questions) ? survey.survey_questions : [];
    const respondents = new Map();

    questions.forEach((survey_question, question_index) => {
      const question_text = survey_question?.question?.question || `Question ${question_index + 1}`;
      const answers = Array.isArray(survey_question?.answers) ? survey_question.answers : [];

      answers.forEach((answer, answer_index) => {
        this.append_survey_results_export_answer(
          respondents,
          survey_question,
          question_text,
          question_index,
          answer,
          answer_index
        );
      });
    });

    return Array.from(respondents.values());
  },
  get_survey_results_export_value(application, header) {
    return get_survey_result_export_value(application, header);
  },
  format_selection_grid_excel_value(value) {
    return format_export_value(value);
  },
  get_excel_column_widths(headers, rows) {
    return get_export_column_widths(headers, rows);
  },
  get_excel_header_style() {
    return get_export_header_style();
  },
  get_excel_data_cell_style() {
    return get_export_data_cell_style();
  },
  get_excel_link_cell_style() {
    return get_export_link_cell_style();
  },
  style_excel_headers(worksheet, headers) {
    headers.forEach((index) => {
      const cell_ref = XLSX.utils.encode_cell({ r: 0, c: index });
      const worksheet_cell = Reflect.get(worksheet, cell_ref);

      if (worksheet_cell) {
        Reflect.set(worksheet_cell, "s", this.get_excel_header_style());
      }
    });
  },
  style_excel_data_cells(worksheet) {
    const worksheet_ref = Reflect.get(worksheet, "!ref");
    const range = XLSX.utils.decode_range(worksheet_ref);

    for (let row = 1; row <= range.e.r; row++) {
      for (let col = 0; col <= range.e.c; col++) {
        const cell_ref = XLSX.utils.encode_cell({ r: row, c: col });
        const worksheet_cell = Reflect.get(worksheet, cell_ref);

        if (worksheet_cell) {
          Reflect.set(worksheet_cell, "s", this.get_excel_data_cell_style());
        }
      }
    }
  },
  apply_survey_results_excel_links(worksheet, raw_export_rows) {
    apply_export_links(worksheet, raw_export_rows);
  },
  build_survey_results_export_headers(survey) {
    return build_export_headers(survey);
  },
  build_survey_results_export_rows(survey_results, export_headers) {
    return build_export_rows(survey_results, export_headers);
  },
  prepare_survey_results_worksheet(export_headers, export_rows) {
    return prepare_worksheet(export_headers, export_rows);
  },
  get_survey_results_export_file_name(survey) {
    const date_stamp = new Date().toISOString().slice(0, 10);
    return `${survey?.name || "survey-results"}-${date_stamp}.xlsx`;
  },
  download_survey_results_excel(survey) {
    const survey_results = this.get_survey_results_export_rows(survey);
    const export_headers = this.build_survey_results_export_headers(survey);

    if (!export_headers.length) {
      this.show_error("There are no survey fields to export.");
      return;
    }

    this.is_downloading_survey_results_excel = true;

    try {
      write_survey_results_export_file(this, survey, survey_results, export_headers);
    } catch (error) {
      this.show_error(error.message || "Failed to export the survey results.");
    } finally {
      this.is_downloading_survey_results_excel = false;
    }
  },
};
